<script>
  import { customer } from "$lib/state/customer";
  import FormCreateUser from "../user/FormCreateUser.svelte";
  import FormSignin from "../user/FormSignin.svelte";

  /**@type {HTMLElement}*/
  let wrapper;
  let isOpenModal = false;

  /** @param {*} event*/
  function handleCartModalEscape(event) {
    if (event.code === "Escape") {
      handleShoppingDialog();
    }
  }
  function handleClickOnBody() {
    handleShoppingDialog();
  }
  /**@param {*} event */
  function stopEventPropagation(event) {
    event.stopPropagation();
  }
  const handleShoppingDialog = () => {
    if (isOpenModal) {
      document.removeEventListener("keyup", handleCartModalEscape);
      document.removeEventListener("click", handleClickOnBody);
      wrapper?.removeEventListener("click", stopEventPropagation);
    } else {
      document.addEventListener("keyup", handleCartModalEscape);
      document.addEventListener("click", handleClickOnBody, { once: true });
      wrapper?.addEventListener("click", stopEventPropagation);
    }
    isOpenModal = !isOpenModal;
  };

  /**
   * here define all modals use for user
   */
  /**@type {HTMLDialogElement}*/
  let signin;
  /**@type {HTMLDialogElement}*/
  let create;

  /**@param {HTMLDialogElement}element*/
  const openModal = (element) => element.showModal();
</script>

<div class="wrap-user-module" bind:this={wrapper}>
  <button id="header-user-login"
    class="user-icon"
    class:login={$customer}
    on:click={handleShoppingDialog}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 32 32"
    >
      <defs>
        <clipPath id="clip-path">
          <circle
            id="Elipse_3"
            data-name="Elipse 3"
            cx="16"
            cy="16"
            r="16"
            transform="translate(-0.149 -0.15)"
          />
        </clipPath>
      </defs>
      <g id="Grupo_285" data-name="Grupo 285" transform="translate(0.505 0.15)">
        <g transform="translate(-0.355 0)" clip-path="url(#clip-path)">
          <path
            d="M0,22.217A12.5,12.5,0,0,1,7.4,10.8a6.588,6.588,0,1,1,10.156,0A12.495,12.495,0,1,1,0,22.217Z"
            transform="translate(3.57 5.828)"
            fill={$customer ? "var(--dark-pink)" : "var(--global)"}
          />
        </g>
      </g>
    </svg>
  </button>

  {#if isOpenModal}
    {#if $customer}
      <div class="user-content">
        <a id="header-my-account-link" href="/customers/account" class="btn-action-url">
          <span>My Account</span>
        </a>
        <p class="msg">NOT {String($customer.firstname).toUpperCase()} ?</p>
        <a id="header-user-logout" href="/customers/signout" class="btn-action-url">
          <span>Sign Out</span>
        </a>
      </div>
    {:else}
      <div class="user-content">
        <button id="header-user-login" class="btn-action-url" on:click={() => openModal(signin)}>
          <span>Sign In</span>
        </button>
        <button id="header-create-account" class="btn-action-url" on:click={() => openModal(create)}>
          <span>Create account</span>
        </button>
      </div>
    {/if}
  {/if}
</div>

<dialog bind:this={signin} id="signin-account">
  <div class="content">
    <FormSignin />
    <button class="close" on:click={() => signin.close()}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22.828"
        height="22.828"
        viewBox="0 0 22.828 22.828"
      >
        <g transform="translate(-6225.086 -15079.086)">
          <line
            x2="10"
            y2="10"
            transform="translate(6226.5 15080.5)"
            stroke="var(--global)"
            stroke-linecap="round"
            stroke-width="2"
          />
          <line
            y1="10"
            x2="10"
            transform="translate(6226.5 15080.5)"
            stroke="var(--global)"
            stroke-linecap="round"
            stroke-width="2"
          />
        </g>
      </svg>
    </button>
  </div>
</dialog>
<dialog bind:this={create} id="create-account">
  <div class="content">
    <FormCreateUser />
    <button class="close" on:click={() => create.close()}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22.828"
        height="22.828"
        viewBox="0 0 22.828 22.828"
      >
        <g transform="translate(-6225.086 -15079.086)">
          <line
            x2="10"
            y2="10"
            transform="translate(6226.5 15080.5)"
            stroke="var(--orange)"
            stroke-linecap="round"
            stroke-width="2"
          />
          <line
            y1="10"
            x2="10"
            transform="translate(6226.5 15080.5)"
            stroke="var(--orange)"
            stroke-linecap="round"
            stroke-width="2"
          />
        </g>
      </svg>
    </button>
  </div>
</dialog>

<style>
  .wrap-user-module {
    position: relative;
  }
  .user-icon {
    width: 3.2rem;
    height: 3.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    cursor: pointer;
    background-color: var(--orange-light);
    border-radius: 50%;
  }
  .login {
    background-color: var(--global);
  }
  .user-icon svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }
  .user-content {
    position: absolute;
    background: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
    max-width: 30rem;
    width: 95svw;
    padding: 3rem;
    gap: 1rem;
    right: 0;
    top: 4.5rem;
    box-shadow: 0px 0.3rem 0.6rem rgba(124, 115, 115, 0.75);
    z-index: 50;
    border-radius: 3rem 0 3rem 3rem;
    animation: popShoppingBag 500ms ease forwards;
    transition: all 0.5s ease;
    overflow: hidden;
    max-height: 64rem;
  }
  .user-content button {
    width: 100%;
  }
  dialog {
    width: 95svw;
    max-width: 82rem;
    border-radius: 3rem;
    border: 0.3rem solid var(--orange);
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0 0 0.3rem rgba(0, 0, 0, 0.17);
  }
  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    position: relative;
    padding: 8rem 4rem 12rem 4rem;
  }
  dialog::backdrop {
    background-color: rgba(0, 0, 0, 0.42);
    backdrop-filter: blur(1rem);
  }
  .close {
    position: absolute;
    top: 3rem;
    right: 0.8rem;
    width: 3.5rem;
    height: 3.5rem;
    border: none;
    background: none;
    cursor: pointer;
  }
  .close svg {
    width: 100%;
    height: 100%;
  }
  .msg {
    font-size: 1.8rem;
    font-weight: 700;
  }
</style>
